import { render, staticRenderFns } from "./SimulatorButton.vue?vue&type=template&id=4df048e8&scoped=true&"
import script from "./SimulatorButton.vue?vue&type=script&lang=js&"
export * from "./SimulatorButton.vue?vue&type=script&lang=js&"
import style0 from "./SimulatorButton.vue?vue&type=style&index=0&id=4df048e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df048e8",
  null
  
)

export default component.exports